import { useEffect, useState } from "react"
import { Dialog, DialogContent, DialogContentText } from "@mui/material"
import NewsLetterForm from "../forms/NewsLetterForm"
import image from "../../assets/images/portrait-smiley-man.png"
import xmark from "../../assets/icons/rounded-xmark.svg"

const key = window.location.origin + "_newsletter"

const NewsLetter = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const doesExistLocal = localStorage.getItem(key)
    const doesExistSession = sessionStorage.getItem(key)
    if (!doesExistLocal && !doesExistSession) {
      setTimeout(() => {
        setIsOpen(true)
      }, 5000)
    }
  }, [])

  const handleClose = (hasSubscribed = false) => {
    if (hasSubscribed) {
      localStorage.setItem(key, "true")
    } else {
      sessionStorage.setItem(key, "true")
    }
    setIsOpen(false)
  }

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiPaper-root": {
          width: "auto",
          maxWidth: "none",
        },
      }}
    >
      <div className="flex">
        <img
          src={image}
          alt="portrait of a man having a good time"
          className="hidden md:flex w-[326px] h-auto"
        />
        <div>
          <DialogContent
            sx={{
              p: { xs: "16px", md: "32px" },
              maxWidth: { md: "499px" },
            }}
          >
            <DialogContentText id="alert-dialog-description">
              <button onClick={() => handleClose()} className="absolute top-2 right-2">
                <img src={xmark} alt="" />
              </button>
              <div className="relative">
                <h2 className="font-bold text-2xl text-[#5C068C] w-fit">Get Weekly Gro Tips</h2>
                <p className="mt-[12px] text-gray-600">
                  Subscribe to free market trends, growth tips, and simple next steps to grow your
                  investments.
                </p>
              </div>
              <div className="mt-[25px]">
                <NewsLetterForm
                  onClose={handleClose}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                />
              </div>
            </DialogContentText>
          </DialogContent>
        </div>
      </div>
    </Dialog>
  )
}

export default NewsLetter
